/* מסמן האם הגלילה חצתה סף נתון — משמש לחשיפת הכותרת העליונה. */
import { useEffect, useState } from 'react';

export function useScrolledPast(threshold: number): boolean {
  const [isPast, setIsPast] = useState(() => window.scrollY > threshold);

  useEffect(() => {
    const handleScroll = (): void => setIsPast(window.scrollY > threshold);

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return isPast;
}
